import {classNames, React, observer} from '@api'
import {InputGroup} from '@blueprintjs/core'
import {useCatalogItemSidebarDetailsStore} from '@modules'
import * as css from './DetailsModalSearch.css'

export const DetailsModalSearch = observer<React.HTMLProps<HTMLDivElement>>(({className, ...props}) => {
  const {sidebar: {searchText, onKeyDown}, search_onChange} = useCatalogItemSidebarDetailsStore()

  return (
    <div
      className={classNames(css.root, className)}>
      <InputGroup leftIcon='search' placeholder={`Search...`} onChange={search_onChange} onKeyDown={onKeyDown} value={searchText ?? ''} />
    </div>
  )
})


// WEBPACK FOOTER //
// ./src/modules/CatalogItemDetails/CatalogItemSidebarDetails/Modal/DetailsModalSearch.tsx